import type { TInclassMessage } from '@cuemath/leap';

import { useInClassMessageBroker as useStudentInClassMessageBroker } from '@cuemath/leap';
import { useAppSelector } from 'hooks';
import useLogEvent from 'hooks/use-log-event';
import { useMemo } from 'react';

const useInclassMessageBroker = (options?: {
  onMessageReceive?: (newMessages: Array<TInclassMessage>, initialData?: boolean) => void;
}) => {
  const { onMessageReceive } = options || {};
  const studentClassroomId = useAppSelector(
    state => state?.status?.student_classroom_id,
  ) as string | undefined;
  const channelId = `inclass_${studentClassroomId}`;
  const inClass = useAppSelector(state => state?.status?.in_class) as boolean | undefined;
  const logEvent = useLogEvent(useMemo(() => ({ channel_id: channelId }), [channelId]));

  return useStudentInClassMessageBroker({
    studentClassroomId: inClass ? studentClassroomId : undefined,
    onMessageReceive,
    logger: logEvent,
  });
};

export default useInclassMessageBroker;
